import type { ReactNode } from "react";

export const DisclaimerList = ({ children }: { children: ReactNode }) => (
  <ul className="my-0 ml-4 list-outside list-disc p-0 leading-5 [&_a]:no-underline">
    {children}
  </ul>
);
